import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api";

export const GetInspections = createAsyncThunk(
  "ls/GetInspections",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/request-inspection/user/request-inspection?page=1&limit=10`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  inspections: {},
};

export const InspectionSlice = createSlice({
  name: "inspections",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(GetInspections.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetInspections.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          inspections: action.payload,
        };
      })
      .addCase(GetInspections.rejected, (state, action) => {
        return {
          isLoading: false,
          error: action.payload,
        };
      });
  },
});

export default InspectionSlice.reducer;
